import React, { useState, useCallback, memo } from "react"
import { useSelector, useDispatch } from "react-redux"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import IconSparcaSettings from "@/assets/icons/IconSparcaSettings"
import { makeStyles } from "@material-ui/core/styles"
import ControlPanelTextField from "@/components/common/ControlPanelTextField"
import { updateSingleProjectByProjectIdRequest } from "@/redux/actions/projectAction"
import useDebounce from "@/hooks/useDebounce"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import useHandleRequestSnackbar from "@/hooks/useHandleRequestSnackbar"

const useStyles = makeStyles((theme) => ({
    formWrapper: {
        padding: theme.spacing(6, 4),
        paddingBottom: "0px",
    },
    controlPanelSidebarFormIcon: {
        marginRight: theme.spacing(2),
    },
    controlPanelSidebarFormTitle: {
        flex: "0 0 auto",
        color: "#ffffff",
    },
    btnSave: {
        "&:disabled": {
            background: "#7c7c7c",
            color: "#fff",
        }
    }
}))

const ProjectSetting = memo(() => {
    const classes = useStyles()
    const [isFormInvalid, setIsFormInvalid] = useState(false)
    const dispatch = useDispatch()
    const { message, successStatus, projects, messagePopup } = useSelector((state) => state.projectReducer)
    const [newProjectName, setNewProjectName] = useState("" || projects[0].projectName)
    const [disableUpdateSave, setDisableUpdateSave] = useState(true)

    const requestSnackbarValue = useHandleRequestSnackbar(messagePopup)
    const validate = useCallback((value) => {
        if (value !== "") {
            setIsFormInvalid(false)
        } else {
            setIsFormInvalid(true)
        }
    }, [])

    const handleSaveProjectName = useDebounce(
        () => {
            validate(newProjectName)
            if (!isFormInvalid) {
                if (newProjectName) {
                    const { projectId } = projects[0]
                    const newProject = {
                        projectName: newProjectName,
                    }
                    dispatch(updateSingleProjectByProjectIdRequest({ projectId, newProject }))
                    setDisableUpdateSave(false)
                }
            }
        },
        500,
        [isFormInvalid, newProjectName]
    )

    const handleFormChange = (event) => {
        setDisableUpdateSave(false)
        setIsFormInvalid(false)
        setNewProjectName(event.target.value)
    }

    return (
        <Box className={classes.formWrapper}>
            <Box display="flex" alignItems="center">
                <IconSparcaSettings width="25" fill="white" className={classes.controlPanelSidebarFormIcon} />
                <Typography variant="h6" component="h2" className={classes.controlPanelSidebarFormTitle}>
                    Project Settings
                </Typography>
            </Box>
            <Box className="project-detail-bottom-wrapper" mt={4}>
                <Box mb={3}>
                    <ControlPanelTextField
                        required
                        label="Project Name"
                        error={isFormInvalid}
                        helperText={isFormInvalid && "project name required"}
                        id="project-name"
                        name="projectName"
                        placeholder="Enter Your Project Name"
                        variant="outlined"
                        fullWidth
                        onChange={handleFormChange}
                        defaultValue={projects[0].projectName}
                    />
                </Box>
            </Box>
            <Box className="sparca-project-setting-wrapper">
                <Box className="button-wrapper">
                    <Button className={classes.btnSave} variant="contained" color="primary" disabled={disableUpdateSave} fullWidth onClick={handleSaveProjectName}>
                        save
                    </Button>
                </Box>
            </Box>
            <RequestSnackbar
                status={successStatus}
                message={message}
                snackbarOpen={requestSnackbarValue.snackbarOpen}
                handleSnackbarOpenStatus={requestSnackbarValue.handleSnackbarOpenStatus}
            />
        </Box>
    )
})

export default ProjectSetting
